var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsideCtaArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99967 13.6673C10.6816 13.6673 13.6663 10.6825 13.6663 7.00065C13.6663 3.31875 10.6816 0.333984 6.99967 0.333984C3.31778 0.333984 0.333008 3.31875 0.333008 7.00065C0.333008 10.6825 3.31778 13.6673 6.99967 13.6673ZM8.01989 4.6471L10.0199 6.6471C10.2152 6.84236 10.2152 7.15894 10.0199 7.35421L8.0199 9.35421C7.82463 9.54947 7.50805 9.54947 7.31279 9.35421C7.11753 9.15894 7.11753 8.84236 7.31279 8.6471L8.45924 7.50065L4.33301 7.50065C4.05687 7.50065 3.83301 7.27679 3.83301 7.00065C3.83301 6.72451 4.05687 6.50065 4.33301 6.50065H8.45923L7.31279 5.35421C7.11753 5.15894 7.11753 4.84236 7.31279 4.6471C7.50805 4.45184 7.82463 4.45184 8.01989 4.6471Z",
    fill: "#030106"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsideCtaArrow);
export default __webpack_public_path__ + "static/media/Inside_CTA_arrow.d11b05f9.svg";
export { ForwardRef as ReactComponent };